import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import MaterialIcons from "../icons/MaterialIcons";
import TextView from "./TextView";
import IconView from "./IconView";
import { BuildContext } from "../classes/BuildContext";

export interface RegisterUsersCountViewProps extends BaseUIProps {
  key?: string;
  count?: number;
}

class _RegisterUsersCountViewState extends ObservableComponent<RegisterUsersCountViewProps> {
  static defaultProps = { count: 0 };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: RegisterUsersCountViewProps) {
    super(props);

    this.initState();
  }
  public get count(): number {
    return this.props.count;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["count"], this.rebuild);
  }
  public componentDidUpdate(prevProps: RegisterUsersCountViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.count !== this.props.count) {
      this.fire("count", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      mainAxisAlignment: ui.MainAxisAlignment.center,
      children: [
        ui.Container({
          child: IconView({
            size: 28,
            icon: MaterialIcons.person,
            color: cStyle.c5,
            className: "xc10 hc vc",
          }),
          className: "x055 hc vc",
          key: "0",
        }),
        TextView({
          data: "Registered Users",
          style: new ui.TextStyle({
            color: cStyle.c4,
            fontSize: cStyle.tTextViewHeadlineFourFontSizeOn,
            fontWeight: cStyle.tTextViewHeadlineFourFontWeightOn,
          }),
          className: "xf88 hc",
          key: "1",
        }),
        TextView({
          data: this.count.toString(),
          style: new ui.TextStyle({ fontSize: 20 }),
          className: "xce hc",
          key: "2",
        }),
        TextView({
          data: "Individuals who have completed a registration process to create an account on a service edge platform.",
          softWrap: true,
          textAlign: ui.TextAlign.center,
          style: new ui.TextStyle({
            fontSize: cStyle.tTextViewDescriptionTextFontSizeOn,
            fontWeight: cStyle.tTextViewDescriptionTextFontWeightOn,
          }),
          className: "x8aa hc",
          key: "3",
        }),
      ],
      className: ui.join(
        this.props.className,
        "RegisterUsersCountView x6c1 hc vc"
      ),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function RegisterUsersCountView(
  props: RegisterUsersCountViewProps
) {
  return React.createElement(_RegisterUsersCountViewState, {
    ..._RegisterUsersCountViewState.defaultProps,
    ...props,
  });
}
